/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseToolSearchCallInProgressEventArgs = {
  query: string;
  maxResults?: number | undefined;
};

export type ResponseToolSearchCallInProgressEvent = {
  type: "response.tool_search_call.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  args?: ResponseToolSearchCallInProgressEventArgs | undefined;
};

/** @internal */
export const ResponseToolSearchCallInProgressEventArgs$inboundSchema: z.ZodType<
  ResponseToolSearchCallInProgressEventArgs,
  z.ZodTypeDef,
  unknown
> = z.object({
  query: z.string(),
  max_results: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    "max_results": "maxResults",
  });
});
/** @internal */
export type ResponseToolSearchCallInProgressEventArgs$Outbound = {
  query: string;
  max_results?: number | undefined;
};

/** @internal */
export const ResponseToolSearchCallInProgressEventArgs$outboundSchema:
  z.ZodType<
    ResponseToolSearchCallInProgressEventArgs$Outbound,
    z.ZodTypeDef,
    ResponseToolSearchCallInProgressEventArgs
  > = z.object({
    query: z.string(),
    maxResults: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      maxResults: "max_results",
    });
  });

export function responseToolSearchCallInProgressEventArgsToJSON(
  responseToolSearchCallInProgressEventArgs:
    ResponseToolSearchCallInProgressEventArgs,
): string {
  return JSON.stringify(
    ResponseToolSearchCallInProgressEventArgs$outboundSchema.parse(
      responseToolSearchCallInProgressEventArgs,
    ),
  );
}
export function responseToolSearchCallInProgressEventArgsFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseToolSearchCallInProgressEventArgs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseToolSearchCallInProgressEventArgs$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseToolSearchCallInProgressEventArgs' from JSON`,
  );
}

/** @internal */
export const ResponseToolSearchCallInProgressEvent$inboundSchema: z.ZodType<
  ResponseToolSearchCallInProgressEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.tool_search_call.in_progress"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  args: z.lazy(() => ResponseToolSearchCallInProgressEventArgs$inboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseToolSearchCallInProgressEvent$Outbound = {
  type: "response.tool_search_call.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
  args?: ResponseToolSearchCallInProgressEventArgs$Outbound | undefined;
};

/** @internal */
export const ResponseToolSearchCallInProgressEvent$outboundSchema: z.ZodType<
  ResponseToolSearchCallInProgressEvent$Outbound,
  z.ZodTypeDef,
  ResponseToolSearchCallInProgressEvent
> = z.object({
  type: z.literal("response.tool_search_call.in_progress"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  args: z.lazy(() => ResponseToolSearchCallInProgressEventArgs$outboundSchema)
    .optional(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseToolSearchCallInProgressEventToJSON(
  responseToolSearchCallInProgressEvent: ResponseToolSearchCallInProgressEvent,
): string {
  return JSON.stringify(
    ResponseToolSearchCallInProgressEvent$outboundSchema.parse(
      responseToolSearchCallInProgressEvent,
    ),
  );
}
export function responseToolSearchCallInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseToolSearchCallInProgressEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseToolSearchCallInProgressEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseToolSearchCallInProgressEvent' from JSON`,
  );
}
